export const ADMIN_PAGE_REGISTRY = [
  {
    key: 'artist-applications',
    label: 'Artist Applications',
    description: 'Review artist applications, approve submissions, and reject with internal notes.',
    path: '/admin/artist-applications',
    requiredGroup: 'artists',
  },
  {
    key: 'temporary-artists',
    label: 'Temporary Artists',
    description: 'Create, edit, and permanently delete admin-managed temporary artist pages.',
    path: '/admin/temporary-artists',
    requiredGroup: 'artists',
  },
  {
    key: 'payments',
    label: 'Payments',
    description: 'Inspect Stripe Connect accounts, retry held payouts, refund orders, and manage payout linkage.',
    path: '/admin/payments',
    requiredGroup: 'payments',
  },
];

export function getVisibleAdminPages(adminGroups = []) {
  const normalizedGroups = Array.isArray(adminGroups) ? adminGroups : [];
  return ADMIN_PAGE_REGISTRY.filter((page) => {
    const requiredGroup = String(page?.requiredGroup || '').trim().toLowerCase();
    if (!requiredGroup) return normalizedGroups.length > 0;
    return normalizedGroups.includes('all') || normalizedGroups.includes(requiredGroup);
  });
}
